// AUTO-GENERATED — Do not edit manually.
// Run `npm run generate-controllers` to regenerate after adding/removing controllers.

import AddressController from "./address_controller.ts"
import AddressDeduplicationController from "./address_deduplication_controller.js"
import ApplyProposalController from "./apply_proposal_controller.js"
import AutoEventController from "./auto_event_controller.js"
import AutocompleteController from "./autocomplete_controller.js"
import BidPriceCheckController from "./bid_price_check_controller.ts"
import BidsBenchmarkController from "./bids_benchmark_controller.ts"
import BulkQuoteSelectController from "./bulk_quote_select_controller.js"
import CharacterCounterController from "./character_counter_controller.js"
import ChartsController from "./charts_controller.ts"
import CitymapController from "./citymap_controller.js"
import ClickableDivController from "./clickable_div_controller.js"
import ClipboardController from "./clipboard_controller.ts"
import CnpjController from "./cnpj_controller.js"
import CollapseToggleController from "./collapse-toggle_controller.ts"
import CollapsibleController from "./collapsible_controller.js"
import CurrencyCollapseController from "./currency-collapse_controller.ts"
import CustomerFormController from "./customer_form_controller.js"
import CustomerSearchController from "./customer_search_controller.js"
import DashboardController from "./dashboard_controller.js"
import DatalistAutosubmitController from "./datalist_autosubmit_controller.ts"
import DeviceSwitchController from "./device_switch_controller.js"
import DistanceSortController from "./distance_sort_controller.js"
import DocsContentController from "./docs_content_controller.ts"
import EmojiPickerController from "./emoji_picker_controller.js"
import EndCustomerSearchController from "./end_customer_search_controller.js"
import EntitiesIndexController from "./entities_index_controller.js"
import EventDispatcherController from "./event_dispatcher_controller.js"
import ExpandableContainerController from "./expandable_container_controller.ts"
import FileDownloadController from "./file_download_controller.js"
import FilePreviewController from "./file_preview_controller.js"
import FilterableListController from "./filterable_list_controller.js"
import FilterableSelectController from "./filterable_select_controller.js"
import FlatpickrController from "./flatpickr_controller.js"
import FormController from "./form_controller.js"
import FormProgressController from "./form_progress_controller.js"
import FormResetController from "./form_reset_controller.js"
import FormValidationController from "./form_validation_controller.js"
import FrameRefreshController from "./frame_refresh_controller.js"
import FrameReloaderController from "./frame_reloader_controller.js"
import HistoryFilteringController from "./history_filtering_controller.js"
import InfiniteScrollController from "./infinite_scroll_controller.js"
import LeafletMarkersController from "./leaflet_markers_controller.ts"
import LoadingButtonController from "./loading_button_controller.js"
import MapAreaFilterController from "./map_area_filter_controller.js"
import MapLeafletController from "./map_leaflet_controller.ts"
import MapLeafletbaseController from "./map_leaflet/base_controller.ts"
import MapTriggerController from "./map_trigger_controller.js"
import MessageComposerController from "./message_composer_controller.js"
import MessageItemController from "./message_item_controller.js"
import MessageListController from "./message_list_controller.js"
import MessagingNavController from "./messaging_nav_controller.js"
import MobileEnhancementsController from "./mobile_enhancements_controller.js"
import MobileProgressController from "./mobile_progress_controller.js"
import MobileStickyFilterController from "./mobile_sticky_filter_controller.js"
import ModalController from "./modal_controller.js"
import NestedFormController from "./nested_form_controller.js"
import NotificationPreferencesController from "./notification_preferences_controller.js"
import NotificationsController from "./notifications_controller.js"
import OnDemandController from "./on_demand_controller.js"
import OrderSearchController from "./order_search_controller.ts"
import PersistCollapseController from "./persist_collapse_controller.ts"
import PopoverController from "./popover_controller.ts"
import PresenceIndicatorController from "./presence_indicator_controller.js"
import PriceCalculatorController from "./price_calculator_controller.js"
import ProviderDeduplicationController from "./provider_deduplication_controller.js"
import ProviderFormController from "./provider_form_controller.js"
import ProviderSearchController from "./provider_search_controller.js"
import QbundleController from "./qbundle_controller.js"
import QuoteSearchController from "./quote_search_controller.js"
import QuoteTabsController from "./quote_tabs_controller.js"
import QuoteUpdateController from "./quote_update_controller.js"
import QuotesFormController from "./quotes_form_controller.js"
import RowMarkerHighlighterController from "./row_marker_highlighter_controller.js"
import RunbookCopyController from "./runbook_copy_controller.ts"
import RunbookLanguageController from "./runbook_language_controller.ts"
import RunbookRunController from "./runbook_run_controller.ts"
import ScrollToController from "./scroll_to_controller.js"
import SearchFormController from "./search_form_controller.js"
import SupplierQuoteFormController from "./supplier_quote_form_controller.js"
import SupplierQuoteSearchController from "./supplier_quote_search_controller.js"
import SwipeActionsController from "./swipe_actions_controller.js"
import TableColumnFilterController from "./table_column_filter_controller.ts"
import TableSortController from "./table_sort_controller.ts"
import TabsController from "./tabs_controller.ts"
import ThemeToggleController from "./theme_toggle_controller.js"
import ThreadPanelController from "./thread_panel_controller.js"
import TimeAgoController from "./time_ago_controller.js"
import ToastController from "./toast_controller.js"
import TocController from "./toc_controller.ts"
import TomSelectController from "./tom_select_controller.js"
import TooltipController from "./tooltip_controller.ts"
import TopologyController from "./topology_controller.ts"
import TopologyFrameRefreshController from "./topology_frame_refresh_controller.ts"
import TypingIndicatorController from "./typing_indicator_controller.js"
import WindowController from "./window_controller.js"

// Registration map: [stimulus_identifier, controller_class]
const controllers = [
  ['address', AddressController],
  ['address-deduplication', AddressDeduplicationController],
  ['apply-proposal', ApplyProposalController],
  ['auto-event', AutoEventController],
  ['autocomplete', AutocompleteController],
  ['bid-price-check', BidPriceCheckController],
  ['bids-benchmark', BidsBenchmarkController],
  ['bulk-quote-select', BulkQuoteSelectController],
  ['character-counter', CharacterCounterController],
  ['charts', ChartsController],
  ['citymap', CitymapController],
  ['clickable-div', ClickableDivController],
  ['clipboard', ClipboardController],
  ['cnpj', CnpjController],
  ['collapse-toggle', CollapseToggleController],
  ['collapsible', CollapsibleController],
  ['currency-collapse', CurrencyCollapseController],
  ['customer-form', CustomerFormController],
  ['customer-search', CustomerSearchController],
  ['dashboard', DashboardController],
  ['datalist-autosubmit', DatalistAutosubmitController],
  ['device-switch', DeviceSwitchController],
  ['distance-sort', DistanceSortController],
  ['docs-content', DocsContentController],
  ['emoji-picker', EmojiPickerController],
  ['end-customer-search', EndCustomerSearchController],
  ['entities-index', EntitiesIndexController],
  ['event-dispatcher', EventDispatcherController],
  ['expandable-container', ExpandableContainerController],
  ['file-download', FileDownloadController],
  ['file-preview', FilePreviewController],
  ['filterable-list', FilterableListController],
  ['filterable-select', FilterableSelectController],
  ['flatpickr', FlatpickrController],
  ['form', FormController],
  ['form-progress', FormProgressController],
  ['form-reset', FormResetController],
  ['form-validation', FormValidationController],
  ['frame-refresh', FrameRefreshController],
  ['frame-reloader', FrameReloaderController],
  ['history-filtering', HistoryFilteringController],
  ['infinite-scroll', InfiniteScrollController],
  ['leaflet-markers', LeafletMarkersController],
  ['loading-button', LoadingButtonController],
  ['map-area-filter', MapAreaFilterController],
  ['map-leaflet', MapLeafletController],
  ['map-leaflet--base', MapLeafletbaseController],
  ['map-trigger', MapTriggerController],
  ['message-composer', MessageComposerController],
  ['message-item', MessageItemController],
  ['message-list', MessageListController],
  ['messaging-nav', MessagingNavController],
  ['mobile-enhancements', MobileEnhancementsController],
  ['mobile-progress', MobileProgressController],
  ['mobile-sticky-filter', MobileStickyFilterController],
  ['modal', ModalController],
  ['nested-form', NestedFormController],
  ['notification-preferences', NotificationPreferencesController],
  ['notifications', NotificationsController],
  ['on-demand', OnDemandController],
  ['order-search', OrderSearchController],
  ['persist-collapse', PersistCollapseController],
  ['popover', PopoverController],
  ['presence-indicator', PresenceIndicatorController],
  ['price-calculator', PriceCalculatorController],
  ['provider-deduplication', ProviderDeduplicationController],
  ['provider-form', ProviderFormController],
  ['provider-search', ProviderSearchController],
  ['qbundle', QbundleController],
  ['quote-search', QuoteSearchController],
  ['quote-tabs', QuoteTabsController],
  ['quote-update', QuoteUpdateController],
  ['quotes-form', QuotesFormController],
  ['row-marker-highlighter', RowMarkerHighlighterController],
  ['runbook-copy', RunbookCopyController],
  ['runbook-language', RunbookLanguageController],
  ['runbook-run', RunbookRunController],
  ['scroll-to', ScrollToController],
  ['search-form', SearchFormController],
  ['supplier-quote-form', SupplierQuoteFormController],
  ['supplier-quote-search', SupplierQuoteSearchController],
  ['swipe-actions', SwipeActionsController],
  ['table-column-filter', TableColumnFilterController],
  ['table-sort', TableSortController],
  ['tabs', TabsController],
  ['theme-toggle', ThemeToggleController],
  ['thread-panel', ThreadPanelController],
  ['time-ago', TimeAgoController],
  ['toast', ToastController],
  ['toc', TocController],
  ['tom-select', TomSelectController],
  ['tooltip', TooltipController],
  ['topology', TopologyController],
  ['topology-frame-refresh', TopologyFrameRefreshController],
  ['typing-indicator', TypingIndicatorController],
  ['window', WindowController],
]

export { controllers }
